// =============================================================================
//  Copyright : 2026 semantics GmbH
//  Author    : Dirk Rothe
//  Purpose   : language fallback for <Language name="..."> sections
//              (visual editor / widget XML content)
// =============================================================================
// ---Framework imports
import { isArray, map, size } from 'ldash';
export const isLanguageNode = (node)=>node && (node.tag == 'language' || node.tag == 'Language');
export const languageNodeHasContent = (node)=>Boolean(node.text && node.text.trim() || node.children && size(node.children));
// Fallback selection for <Language> sections, mirroring the server-side
// behavior of filterLanguageParts for markdown editorial texts: prefer the
// requested language, then the order of dconfig.language.preference (with
// CURRENT_LANG placeholder), then the first non-empty section.
export const selectLanguageSection = (siblings, language, dconfig)=>{
    let isAvailable = (lang)=>siblings.some((s)=>s.attrib?.name == lang && languageNodeHasContent(s));
    if (isAvailable(language)) {
        return language;
    }
    let preference = [];
    let prefSection = dconfig?.language?.preference;
    let pref = prefSection && (prefSection[language] || prefSection.DEFAULT);
    if (isArray(pref)) {
        preference = map(pref, (l)=>l == 'CURRENT_LANG' ? language : l);
    } else {
        preference = [
            language
        ];
    }
    for (let lang of preference){
        if (isAvailable(lang)) {
            return lang;
        }
    }
    let firstNonEmpty = siblings.find((s)=>s.attrib?.name && languageNodeHasContent(s));
    return firstNonEmpty ? firstNonEmpty.attrib.name : language;
};
// template build() for the <Language> wiki template (see wiki/templates.js)
export const buildLanguageTemplate = ({ tail, language, attrib, applyTemplates, parent, dconfig })=>{
    if (!attrib.name) {
        return [
            ...applyTemplates(),
            tail
        ];
    }
    let siblings = (parent?.children || []).filter(isLanguageNode);
    let selected = siblings.length ? selectLanguageSection(siblings, language, dconfig) : language;
    if (attrib.name == selected) {
        return [
            ...applyTemplates(),
            tail
        ];
    }
};
